import { Route } from '@angular/router';
import { MaintenancePageComponent } from '@shared/components';
import { AuthGuard, NoAuthGuard } from '@shared/guards';

export const APP_ROUTES: Route[] = [
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth').then((m) => m.AUTH_ROUTES),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'app',
    loadChildren: () => import('./modules/home').then((m) => m.HOME_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: '404',
    loadChildren: () => import('./modules/error-page-not-found').then((m) => m.ERROR_ROUTES),
  },
  {
    path: '',
    redirectTo: 'app/business-accounts',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
